export const toHalfWidthNumber = (value: string): string => {
  return value.replace(/[０-９]/g, (s) =>
    String.fromCharCode(s.charCodeAt(0) - 65248),
  )
}

export const formatPostalCode = (part1: string, part2: string): string => {
  if (!part1 && !part2) return ''
  return `${part1 || ''}-${part2 || ''}`
}

export const splitPostalCode = (
  postalCode: string,
): { postalCode1: string; postalCode2: string } => {
  const [postalCode1 = '', postalCode2 = ''] = postalCode.split('-')
  return { postalCode1, postalCode2 }
}

export const trimFull = (str: string): string => {
  if (!str) return str
  return str.replace(/^[\s\u3000]+|[\s\u3000]+$/g, '')
}
